import { Component, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FormMode } from '../../common/form-mode';
import { WorkflowDataInterface } from '../workflow-data.interface';

import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { Subject } from 'rxjs';
import { ContextualMenuEvent } from '../contextual-menu-event';

@Component({
    selector: 'app-workflow-not-implemented-action-data',
    imports: [FormsModule, ReactiveFormsModule, MatFormFieldModule, MatInputModule, MatTooltipModule],
    templateUrl: './workflow-not-implemented-action-data.component.html',
    styleUrl: './workflow-not-implemented-action-data.component.scss',
})
export class WorkflowNotImplementedActionDataComponent implements WorkflowDataInterface, OnInit {
    /**
     * Données affichées par le composant dynamique.
     */
    public _data: string;

    /**
     * Spécifie les données affichées par le composant dynamique.
     */
    set data(value: string) {
        this._data = value;
    }

    /**
     * Obtient les données affichées par le composant dynamique.
     */
    get data(): string {
        return this._data;
    }

    /**
     * Mode d'affichage du formulaire.
     */
    mode: FormMode;

    /**
     * Source du menu contextuel.
     */
    contextualMenuSource: Subject<ContextualMenuEvent> = new Subject<ContextualMenuEvent>();

    /**
     * Constructeur.
     */
    constructor() {}

    /**
     * Appellé lors de l'initialisation du contrôle.
     */
    ngOnInit(): void {}

    /**
     * Indique si le formulaire est valide.
     */
    public isValid(): boolean {
        return true;
    }

    /**
     * Retourne une valeur indiquant si l'utilisateur a modifié des valeurs du formulaire.
     */
    public get dirty(): boolean {
        return false;
    }

    /**
     * Annulle les changements effectués par l'utilisateur.
     */
    public clearData() {}
}
